import { render, staticRenderFns } from "./template.vue?vue&type=template&id=317de9b7&scoped=true"
import script from "./template.vue?vue&type=script&lang=js"
export * from "./template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317de9b7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('317de9b7')) {
      api.createRecord('317de9b7', component.options)
    } else {
      api.reload('317de9b7', component.options)
    }
    module.hot.accept("./template.vue?vue&type=template&id=317de9b7&scoped=true", function () {
      api.rerender('317de9b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/view/components/setting-design/template.vue"
export default component.exports